<template>
  <div class="container">
    <div style = "position: absolute;
    color: #ffffff;
    left: 2.5vh;
    top: -4vh;
    z-index: 999;
    font-size: calc(100vw * 14 / 1920);
    display: flex;
    align-items: center;
    cursor: pointer;"
         @click="goIndex()">
      <img
          class="label_1"
          referrerpolicy="no-referrer"
          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngbab5f198dfc4bdb15571a116b3d9e4cde6067c4d38c292b039ea2618876a9b7d"
      />
      <span class="text_1">返回首页</span>
    </div>
    <div class="right-container">

      <div class="right-top">
            <div style="display: flex; height: 4.6vh;padding-bottom: 3vh;">
              <div class="query" v-bind:class=" card === 'total'?'light':''" @click="chooseCard('total')">汇总</div>
              <div class="query" v-bind:class=" card === 'cun'?'light':''" @click="chooseCard('cun')">村级</div>
              <div class="query" v-bind:class=" card === 'company'?'light':''" @click="chooseCard('company')" >公司单位</div>
              <div class="query" v-bind:class=" card === 'ju'?'light':''" @click="chooseCard('ju')">居委</div>
              <div class="query" v-bind:class=" card === 'guo'?'light':''" style=" width: 9vw;" @click="chooseCard('guo')">行政事业单位国有资产</div>
            </div>
      </div>

      <div v-if=" card === 'total'" style="color: rgba(2, 181, 255, 1);font-size: calc(100vw * 24 / 1920);text-align: center;padding-bottom: 5vh;padding-top: 2vh;">
        镇属房屋资产汇总表
      </div>

      <div>

          <div class="query light" style="width: 70px;text-align: center;" @click="exportList()">导出</div>


        <div style="text-align: right;color: #FFFFFF">单位：m²</div>
        <el-table
            :data="totalList"
            :header-cell-style="headerStyle"
            :cell-style="rowStyle"
            @row-click="handleRowClick"
        >
          <el-table-column prop="classification" label="分类"></el-table-column>
          <el-table-column prop="floorArea" label="建筑面积"></el-table-column>
          <el-table-column prop="beOccupiedArea" label="占地面积"></el-table-column>
          <el-table-column prop="certifiedFloorArea" label="有证建筑面积" ></el-table-column>
          <el-table-column prop="unCertifiedFloorArea" label="无证建筑面积"></el-table-column>
          <el-table-column prop="selfUsebuildings" label="自用处数" ></el-table-column>
          <el-table-column prop="selfUseArea" label="自用面积" ></el-table-column>
          <el-table-column prop="rentOutArea" label="出租面积"></el-table-column>
          <el-table-column prop="yearRent" label="年租金(万元/年)" ></el-table-column>
          <el-table-column prop="inIdleBuildings" label="闲置处数" ></el-table-column>
          <el-table-column prop="inIdleArea" label="闲置面积" ></el-table-column>
          <el-table-column  v-if="card === 'cun'" prop="productionGroupNum" label="生产组处数(套)" width="150"></el-table-column>
          <el-table-column  v-if="card === 'cun'" prop="productionGroupArea" label="生产组面积" width="160"></el-table-column>
          <el-table-column v-if="card === 'company'" prop="stockInIdleHouse" label="存量安置房屋数量(套)" width="150"></el-table-column>
          <el-table-column v-if="card === 'company'" prop="stockInIdleArea" label="存量安置房屋面积" width="160"></el-table-column>


        </el-table>
      </div>
    </div>

  </div>

</template>

<script>
import {getTotalList, deleteUser, isSuperManager, houseExportList} from "@/api/Hosing";
import  Point  from "@/components/housingPoint.vue";
import  Summary  from "@/components/housingSummary.vue";
import  Property  from "@/components/housingProperty.vue";
export default {
  name: "userJurisdiction",
  data() {
    return {
      form: {
        nickName: "",
        userName: "", // 手机号
        etName:'', // 企业
      },
      totalList: [],
      currentPage: 1,
      pageSize: 15,
      total: 0,
      card:'total',
      cardLight:true
    };
  },
  components:{
    Point,
    Summary,
    Property
  },
  methods: {
    chooseCard(e){
      this.card = e;
      let data;
      if (e==='total'){
         data = 0;
      }else if(e ==='cun'){
         data = 1;
      }else if(e ==='company'){
         data = 2;
      }else if(e ==='ju'){
         data = 3;
      }else {
         data = 4;
      }
      getTotalList(data).then((res) => {
        this.totalList = res.data;
      });
    },
    exportList(){
      let e = this.card;
      let data;
      if (e==='total'){
        data = 0;
      }else if(e ==='cun'){
        data = 1;
      }else if(e ==='company'){
        data = 2;
      }else if(e ==='ju'){
        data = 3;
      }else {
        data = 4;
      }
      houseExportList(data).then((res) => {
        console.log(res,'res')
        console.log("ImageDownload`" +res.msg +"`" );
        this.$message({
          showClose: false,
          message: "导出成功",
          type: "success",
        });
      });
    },
    handleRowClick(row, column, event) {
      console.log(row,'row11'); // 被点击的行数据对象，包含了行中的所有数据。可以在这里进行你需要的操作。例如：打印行数据。
      console.log(column); // 被点击的列数据对象，包含了列的属性信息。可以在这里进行你需要的操作。例如：打印列属性。
      console.log(event); // 原生的事件对象，包含了事件的一些信息。可以在这里进行你需要的操作。例如：阻止事件的默认行为。
      if (this.card !=='total'){
        if(row.classification==='总计'){
          return;
        }
        this.$router.push({ path: '/housing', query: { id: row.id }});
      }else {
        var data;
        if(row.classification==='村级'){
          this.card = 'cun';
          data = 1;
        }else if(row.classification==='公司单位'){
          this.card = 'company';
          data = 2;
        }else if(row.classification==='居委'){
          this.card = 'ju';
          data = 3;
        }else if(row.classification==='行政事业单位国有资产'){
          this.card = 'guo';
          data = 4;
        }else {
          return;
        }
        getTotalList(data).then((res) => {
          this.totalList = res.data;
        });
      }
    },

    goIndex(){
      this.$router.push("/index");
    },
    headerStyle() {
      return "background:#0F2455;color:#fff;border: 1px solid #286AE8;text-align:center";
    },
    rowStyle() {
      return "background:#0F2455;color:#fff;border: 1px solid #286AE8;text-align:center";
    },
    getList() {
      getTotalList(0).then((res) => {
        console.log(res, "阿什杜阿虎");
        this.totalList = res.data;

      });
    },
  },
  mounted() {
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.container::v-deep {
  margin-top: 2vh;
  width: 100%;
  position: relative;
  .left-title {
    position: absolute;
    left: 0;
    top: 0;
    background: url(@/assets/images/titleBg.png);
    background-size: 100% 100%;
    width: 11.1vw;
    height: 5.5vh;
    color: #fff;
    font-size: calc(100vw * 20 / 1920);
    text-align: center;
    line-height: 5.5vh;
    margin-right: 4vw;
  }
  .right-container {
    width: 81vw;
    position: absolute;
    left: 3vw;
    right: 0;
    margin: 0 auto;

    .right-top {

      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-form-item {
        display: flex;
        align-items: center;
        height: 4.6vh;

        .el-input__inner {
          width: 100%;
          height: 4.6vh;
          font-size: calc(100vw * 16 / 1920);
          box-shadow: inset 0rem 0rem 0.43rem 0.17rem rgba(44, 98, 230, 0.28);
          border-radius: 6px;
          border: 0.02rem solid #286ae8;
          background: none;
          color: #fff;
          &::placeholder {
            color: #fff;
          }
        }
        .el-form-item__label {
          width: 6.5vw;
          text-align: left;
          color: #fff;
          font-size: calc(100vw * 16 / 1920);
        }
      }
      .query,
      .reset {
        width: 8vw;
        height: 100%;
        background: url(@/assets/images/updown.png);
        background-size: 100% 100%;
        color: #02b5ff;
        font-size: calc(100vw * 16 / 1920);
        line-height: 4.6vh;
        text-align: center;
        cursor: pointer;
      }
      .query {
        margin-right: 1vw;
      }
    }
  }
}
::v-deep .el-form {
  width: 65vw;
  padding-left: 10vw;
  box-sizing: border-box;
}
::v-deep .el-table {
  width: 99.9%;
  margin-bottom: 2.5vh;
  font-size: calc(100vw * 16 / 1920);
}
::v-deep .el-table__body {
  font-size: calc(100vw * 14 / 1920);
}
::v-deep .el-table__row {
  height: 4vh;
}
.el-table--border::after,
.el-table--group::after,
.el-table::before {
  display: none;
}
::v-deep .el-pagination {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1vh;
}
::v-deep .el-pagination .el-select .el-input .el-input__inner,
::v-deep .el-pagination .btn-next,
::v-deep .el-pagination .btn-prev,
::v-deep .el-pager li,
::v-deep .el-pager li.btn-quicknext,
::v-deep .el-pager li.btn-quickprev,
::v-deep .el-pagination__total {
  //background: #0f2455;
  border-radius: 6px;
  border: 1px solid #286AE8;
  box-shadow: inset 0px 0px 20px 21px rgba(15,53,116,0.6);
  color: #fff;
  text-align: center;
}
::v-deep .el-pager li,
::v-deep .el-pagination .btn-next,
::v-deep .el-pagination .btn-prev {
  margin-right: 0.5vw;
}
::v-deep .el-pagination__total {
  margin-right: 0;
  padding: 0 0.8vw;
  box-sizing: border-box;
}
::v-deep .el-form-item__content {
  height: 4.6vh;
}
::v-deep .el-pager li.active {
  color: #409EFF;
}

.light{
  background: url(@/assets/use/btn3.png) !important;
  background-size: 100% 100% !important;
  color: #2EE6FE !important;

}
</style>
